/* eslint-disable  */
export const manuItems = [
    { id: 1, title: 'ABOUT', link: '/about' },
    { id: 2, title: 'CERTIFICATES', link: '/certificates' },
    { id: 3, title: 'FORMS', link: '/forms' },
    { id: 4, title: 'CONTACTS', link: '/solutions' },
    { id: 5, title: 'LOGIN', link: '/admin' },
    // { id: 5, title: 'GET IN TOUCH', link: '/get-in-touch' },
];
